<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <div class="project-page-content">

        <!-- header row -->
        <div class="project-page-header-row">

          <!-- project logo -->

          <span class="project-list-row-cell logo-cell" style="min-width: 140px;">

            <p-inplace
              [disabled]="!isAdmin()"
              #inplace3
              class="orgclass-logo-{{organization.id}} light"
              closable="closable"
              (onDeactivate)="orgEditLogoDeactivate(organization.id, inplace3)"
              (onActivate)="orgEditLogoActivate(organization.id, inplace3)"
              (keyup)="orgEditLogoKey($event, organization.id, inplace3)">

              <ng-template pTemplate="display">
                <img src="{{organization.logo_url ? organization.logo_url : '/assets/images/default-project-logo.png'}}" referrerpolicy="no-referrer">
              </ng-template>

              <ng-template pTemplate="content">
                <input type="text" value="{{organization.logo_url}}" pInputText>
              </ng-template>

            </p-inplace>

          </span>

          <!-- project key -->

          <span class="project-list-row-cell" style="vertical-align: unset;">
              <span style="display: inline-block; margin-left: 12px; margin-right: 12px; vertical-align: top;">{{organization.key}}</span>
           </span>

          <!-- project's org, its name,  description -->

          <span class="project-list-row-cell" style="vertical-align: unset;">

            <span style="font-size: 24px; color: black; font-weight: normal; display: block;">

              <p-inplace
                [disabled]="!isAdmin()"
                #inplace1
                class="orgclass-name-{{organization.id}} light"
                closable="closable"
                (onDeactivate)="orgEditNameDeactivate(organization.id, inplace1)"
                (onActivate)="orgEditNameActivate(organization.id, inplace1)"
                (keyup)="orgEditNameKey($event, organization.id, inplace1)">

                <ng-template pTemplate="display">
                  <b>{{ organization.name }}</b>
                </ng-template>

                <ng-template pTemplate="content">
                  <input type="text" value="{{organization.name}}" pInputText>
                </ng-template>

              </p-inplace>

              </span>

              <span style="font-size: 11px; font-weight: normal; color: grey;">

                <p-inplace
                  [disabled]="!isAdmin()"
                  #inplace2
                  class="orgclass-desc-{{organization.id}} light"
                  closable="closable"
                  (onDeactivate)="orgEditDescDeactivate(organization.id, inplace2)"
                  (onActivate)="orgEditDescActivate(organization.id, inplace2)"
                  (keyup)="orgEditDescKey($event, organization.id, inplace2)">

                  <ng-template pTemplate="display">
                    <i style="font-size: 14px;">{{organization.description}}</i>
                  </ng-template>

                  <ng-template pTemplate="content">
                    <input type="text" value="{{organization.description}}" pInputText>
                  </ng-template>

                </p-inplace>

              </span>

            </span>

        </div>

        <div *ngIf="isAdmin()"  class="projectaddmember">

          <div style="width: 45%; display: inline-block;vertical-align: top;">

            <!-- add new (random) project members -->

            <label style="margin-right: 4px;">Add Administrator:</label>

            <p-autoComplete
              [(ngModel)]="newAdmin"
              [suggestions]="searchAdmins"
              (completeMethod)="search($event)"
              (onSelect)="linkAdmin($event)"
              field="label"
              class="light">

              <ng-template let-match pTemplate="item">
                <div [innerHTML]="formatMatch(match.label)"></div>
              </ng-template>

            </p-autoComplete>

          </div>

          <div style="width: 50%; display: inline-block;">

            <!-- system admins and org admins may create projects in their administered orgs -->

            <p-inputgroup>

              <input (keyup)="checkKey()" id="createprojectkeylight" type="text" pInputText placeholder="Key">
              <input (keyup)="checkKey($event)" id="createprojectlight" type="text" pInputText placeholder="New Project">

              <div *ngIf="prjInputValid; else cancelButton">
                <button (click)="createProject()" type="button" pButton pRipple icon="pi pi-check" [class.p-button-danger]="!prjInputValid" [class.p-button-success]="prjInputValid"></button>
              </div>

              <ng-template #cancelButton>
                <button (click)="createProject()" type="button" pButton pRipple icon="pi pi-times" [class.p-button-danger]="!prjInputValid" [class.p-button-success]="prjInputValid"></button>
              </ng-template>

              <ng-template #cancelButton>
                <button (click)="createProject()" type="button" pButton pRipple icon="pi pi-times" [class.p-button-danger]="!prjInputValid" [class.p-button-success]="prjInputValid"></button>
              </ng-template>

            </p-inputgroup>

            <div>
              <p class="prjcreateerror"></p>
            </div>

          </div>

        </div>

        <div *ngIf="organization.pending_users.length && isAdmin()" style="margin-top: 24px;" class="project-page-instructions-row">

          <h6>New Administrators?</h6>

          <user-list-component
            [editable]="isAdmin()"
            [pending]="true"
            [org]="organization"
            [users]="organization.pending_users"
            (member_approve)="approve($event)"
            (member_approve_and_add)="approveAndLink($event)"
          >
          </user-list-component>

        </div>

        <!-- 3 columns, the subdivision selector, and organizational admins -->
        <div style="margin-top: 48px; width: 100%;" class="project-page-instructions-row">

          <div class="project-page-subs">

            <div *ngIf="allSubs.length">

              <subdivision-list-component
                [subdivisions]="allSubs"
                [editable]="isSystemAdmin()"
                [org]="organization"
                mode="organization"
              >

              </subdivision-list-component>

            </div>

          </div>

          <div class="project-admins">

            <h6>Administrators</h6>

            <user-list-component
              [editable]="isAdmin()"
              [org]="organization"
              [users]="organization.admins"
              (admin_unlinked)="unlinkAdmin($event)"
              >
            </user-list-component>

          </div>

          <div class="project-admins">

            <h6>Projects</h6>

            <project-list-component
              mini="true" [editable]="isAdmin()"
              [projects]="organization.projects"
              (projectDeleted)="projectDeleted($event)"
            >

            </project-list-component>

          </div>

          <div style="clear: both; height: 1px;"></div>

        </div>

        <!-- user instructions -->
        <div class="project-page-instructions-row">

          <p-accordion class="light">

            <p-accordionTab header="Help">

              <p>
                Organization details below.  Only system admins can modify the subsystems
                assigned to an organization.  All changes are saved as you make them. To edit
                text fields, click for inline editing.
              </p>

            </p-accordionTab>

          </p-accordion>

        </div>

      </div>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>
</div>
